"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Roles = void 0;
exports.instanceOfRoles = instanceOfRoles;
exports.RolesFromJSON = RolesFromJSON;
exports.RolesFromJSONTyped = RolesFromJSONTyped;
exports.RolesToJSON = RolesToJSON;
exports.RolesToJSONTyped = RolesToJSONTyped;
/**
 *
 * @export
 */
exports.Roles = {
    FacilityAdministrator: 'Facility administrator',
    PlatformAdministrator: 'Platform administrator',
    Nurse: 'Nurse'
};
function instanceOfRoles(value) {
    for (const key in exports.Roles) {
        if (Object.prototype.hasOwnProperty.call(exports.Roles, key)) {
            if (exports.Roles[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function RolesFromJSON(json) {
    return RolesFromJSONTyped(json, false);
}
function RolesFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RolesToJSON(value) {
    return value;
}
function RolesToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=Roles.js.map